<template>
    <div class="home animated fadeIn">
        <!-- <f-onboarding/> -->
        <f-intro-emk v-if="specificService"/>
        <f-intro-home v-else/>
        <router-view></router-view>
    </div>
</template>

<script>
import fIntroHome from '@/components/introductions/f-home';
import fIntroEmk from '@/components/introductions/f-emk';
import fOnboarding from '@/components/introductions/f-onboarding';

export default {
    computed: {
    },

    created() {
    },

    components: {
        fOnboarding,
        fIntroHome,
        fIntroEmk,
    }
}
</script>
